/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseSortReqVo
 */
export interface WarehouseSortReqVo {
    /**
     * 仓库ID列表（按顺序排列）
     * @type {Array<number>}
     * @memberof WarehouseSortReqVo
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the WarehouseSortReqVo interface.
 */
export function instanceOfWarehouseSortReqVo(value: object): value is WarehouseSortReqVo {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function WarehouseSortReqVoFromJSON(json: any): WarehouseSortReqVo {
    return WarehouseSortReqVoFromJSONTyped(json, false);
}

export function WarehouseSortReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseSortReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function WarehouseSortReqVoToJSON(json: any): WarehouseSortReqVo {
    return WarehouseSortReqVoToJSONTyped(json, false);
}

export function WarehouseSortReqVoToJSONTyped(value?: WarehouseSortReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

